import { Badge, BlockStack, Card, InlineStack } from '@shopify/polaris'

import { HelpTitle } from '../common/HelpIcon'
import { mainThemeId, ThemeSettings } from '../common/themes'
import {
  ThemeProductEditButton,
  WidgetAppBlockInstallButton,
} from '../settings-page/SubscriptionWidgetCard'

const SubscriptionWidgetStatus = ({ settings }: { settings: ThemeSettings }) => {
  const installed = settings.subscriptionWidgetInstalled
  const themeSupportsAppBlocks = settings.themeSupportsAppBlocks

  return (
    <InlineStack gap="200" blockAlign="center" align="space-between">
      <HelpTitle title="Subscription widget app block">
        The subscription widget displays available selling plans on the product page
      </HelpTitle>
      <Badge size="small" tone={installed ? 'success' : undefined}>
        {installed ? 'On' : themeSupportsAppBlocks ? 'Off' : 'Not supported'}
      </Badge>
    </InlineStack>
  )
}

const SubscriptionWidgetControlButtons = ({ settings }: { settings: ThemeSettings }) => {
  const installed = settings.subscriptionWidgetInstalled
  const themeSupportsAppBlocks = settings.themeSupportsAppBlocks

  if (installed) {
    return (
      <ThemeProductEditButton themeId={mainThemeId(settings)}>Edit settings</ThemeProductEditButton>
    )
  }

  return (
    <WidgetAppBlockInstallButton
      themeId={mainThemeId(settings)}
      themeSupportsAppBlock={themeSupportsAppBlocks}
      onAddWidgetClick={() => {}}
      variant="primary"
    >
      Install widget
    </WidgetAppBlockInstallButton>
  )
}

export const SubscriptionWidgetStatusCard = ({ settings }: { settings: ThemeSettings }) => (
  <Card>
    <BlockStack gap="200">
      <SubscriptionWidgetStatus settings={settings} />
      <InlineStack gap="200">
        <SubscriptionWidgetControlButtons settings={settings} />
      </InlineStack>
    </BlockStack>
  </Card>
)
